import { FE_BATCH_8_CATEGORY_SUPPLIERS_PAGE_CTA_250310 } from "@faire/retailer-settings/FE_BATCH_8_CATEGORY_SUPPLIERS_PAGE_CTA_250310";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingCategorySuppliersPageCTA = (): boolean =>
  useSetting(FE_BATCH_8_CATEGORY_SUPPLIERS_PAGE_CTA_250310);

export const useAssignSettingCategorySuppliersPageCTA = () =>
  useAssignSetting(FE_BATCH_8_CATEGORY_SUPPLIERS_PAGE_CTA_250310);
